import { ControlPropertiesType, ControlSchemaType } from '../ControlTypes';

const buttonHiddenConfig: ControlPropertiesType = {
  hidden: true,
};
const inputAsTextConfig: ControlPropertiesType = {
  asText: true,
};

export const startUp: ControlSchemaType = {
  generalInformation: {
    name: inputAsTextConfig,
    code: inputAsTextConfig,
    sponsorId: inputAsTextConfig,
    dataStorageLocationId: inputAsTextConfig,
    description: {},
    iagStudyEmail: {},
    dashboardUrl: {},
    ctGovLink: {},
    eudraCt: {},
    phase: inputAsTextConfig,
    therapeuticArea: inputAsTextConfig,
    disease: inputAsTextConfig,
    drugMolecule: {},
    dicomViewerVersion: inputAsTextConfig,
    startDate: inputAsTextConfig,
    endDate: inputAsTextConfig,
    firstPatientVisit: inputAsTextConfig,
    lastPatientVisit: inputAsTextConfig,
    siteHypothesis: inputAsTextConfig,
    patientHypothesis: inputAsTextConfig,
    visitHypothesis: inputAsTextConfig,
  },
  imagingLabels: {
    addLabel: buttonHiddenConfig,
    deleteLabel: buttonHiddenConfig,
  },
  visits: {
    addCohort: buttonHiddenConfig,
    deleteCohort: buttonHiddenConfig,
    editCohort: buttonHiddenConfig,
    addVisit: buttonHiddenConfig,
    deleteVisit: buttonHiddenConfig,
    editVisit: buttonHiddenConfig,
  },
  team: {
    deleteTeamMember: buttonHiddenConfig,
  },
  forms: {
    assignForm: buttonHiddenConfig,
    editForm: buttonHiddenConfig,
    deleteForm: buttonHiddenConfig,
  },
};
